const DEFAULT_COLOR = 'white';

export default class Spinner {
  constructor({ color } = {}) {
    this.color = color || DEFAULT_COLOR;
  }

  build = () => {
    const wrapper = document.createElement('div');
    const spinner = document.createElement('div');

    wrapper.classList.add('spinner__wrapper', 'js-spinner');
    spinner.classList.add('spinner', `spinner--${this.color}`);
    wrapper.appendChild(spinner);

    return wrapper;
  };
}
